/**
 * @file
 * The Auto Data Service reflects all the services to fetch the auto data on
 * other services
 */
export class AutoDataService {

    constructor($http, $window, edmundsService) {
        this.$http = $http;
        this.$window = $window;

        this.vehicleApiUrl = '/';
        this.edmundsService = edmundsService;

        // look for configuration on window object on init. This allows easy configuration
        // for consumers who do not want to know about angular. This is primarily intended for
        // testing and demo's with non-production backends. It must be set in a <script> tag
        // prior to bootstrapping angular.
        if ($window['jangl'] && $window['jangl'].vehicleApiUrl) {
            this.vehicleApiUrl = $window['jangl'].vehicleApiUrl;
        }
    }

    /**
     * Returns an Object with all the car makes per year
     * @return Object - with all the makes per year
     */
    getVehicleYearMake() {
        let url = this.vehicleApiUrl + 'index.json';
        let request = {
            method: 'GET',
            url: url,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };
        return this.$http(request).then((response) => { return response.data });
    }

    /**
     * Returns an Object with all the car model and detail url per year
     * @return Object - with all the car model and detail url per year
     */
    getVehicleModelSubmodel(year) {
        let url = this.vehicleApiUrl + year + '.json';
        let request = {
            method: 'GET',
            url: url,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };
        return this.$http(request).then((response) => { return response.data });
    }

    /**
     * Build a url with the source of the provider logo
     * @return String - source logo of AutoData API
     */
    getAutoDataLogoUrl() {
        return this.edmundsService.getEdmundsLogoUrl();
    }

    /**
     * Fetch the details of specific year/model/make car using Edmunds service.
     * @param url - (String) Url detail to be requested on Edmunds site.
     * @return Object - Vehicle styles details.
     */
    getVehicleSubmodelOptions(url) {
        return this.edmundsService.getVehicleStyles(url);
    }

    /**
     * format a string to a vin format.
     * @param squishVin - (String) Squished vin (0123456789).
     * @return String - 01234567*9******* Vin with the expected format
     */
    formatSquishVin(squishVin) {
        return `${squishVin.substring(0,8)}*${squishVin.charAt(9)}*******`;
    }
}

AutoDataService.$inject = ['$http', '$window', 'janglEdmundsService'];



// WEBPACK FOOTER //
// ./app/jangl/AutoDataService.js